export enum AnswerTypes {
    RADIO,
    CHECKBOX,
    TEXT,
    SKIP
}